import { render, staticRenderFns } from "./adminapproval.vue?vue&type=template&id=38a6e865&"
import script from "./adminapproval.vue?vue&type=script&lang=js&"
export * from "./adminapproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports